import React, { SVGProps, useId } from "react";

export const WoodIcon = (props: SVGProps<SVGSVGElement>) => {
  const a = useId();
  const b = useId();
  const c = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      viewBox="0 0 128 128"
      {...props}
    >
      <path fill="#633d35" d="m37.29 113.26-8.42 4.48V97.58l10.52 11.2z" />
      <path
        fill="#ad7156"
        d="M99.99 19.95c0 3.02.51 21.49.51 21.49s.26 1.98 1.75 2.48c.98.33 3.12-.37 5.73-2.41.35-.27.82-.31 1.2-.09 1 .6 3.15 1.77 4.5 5.32 1.49 3.92 1.21 7.22.98 8.62-.08.47-.3.9-.57 1.24-2.43 3-14.59 18.58-14.59 28.48 0 0 .2 14.45.2 22.95 0 7.75-13.09 14.22-30.49 15.72l-9.71-2.67-11.2 2.01c-3.56-.55-6.88-1.31-9.86-2.25l-7.47-21.02-2.1 17.92s-5.61-5.75-5.61-9.71c0-8.57-2.1-88.03-2.1-88.03l78.83-.05z"
      />
      <linearGradient
        id={a}
        x1={102.035}
        x2={102.017}
        y1={43.768}
        y2={43.832}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#ce8963" />
        <stop offset={1} stopColor="#d08a61" stopOpacity={0} />
      </linearGradient>
      <path fill={`url(#${a})`} d="M102.25 43.91z" />
      <path
        fill="#ce8963"
        d="M47 35.58c-.33 5.56-.91 11.07-1.53 16.57l-.93 8.23c-.29 2.74-.67 5.45-.59 8.08 0 2.7.13 5.46.27 8.21l.37 8.28c.24 5.53.45 11.06.41 16.63-1.2-5.44-2.05-10.93-2.74-16.44-.68-5.52-1.21-11.02-1.31-16.67-.02-2.91.4-5.71.78-8.46.44-2.75.88-5.49 1.43-8.21 1.07-5.45 2.29-10.86 3.84-16.22zM34 63.58c.27.7.3 1.46.38 2.19.05.74.1 1.48.12 2.22.04 1.48.06 2.96.04 4.44-.02 2.96-.13 5.91-.29 8.86-.15 2.95-.35 5.89-.59 8.83-.21 2.94-.52 5.88-.81 8.82l-.03-.36 1.42 5.21 1.35 5.23c.87 3.5 1.7 7 2.41 10.55-1.32-3.36-2.52-6.77-3.68-10.18l-1.7-5.13L31 99.13l-.05-.16.02-.19c.25-2.93.46-5.87.74-8.81.25-2.93.53-5.87.82-8.8l.89-8.79.43-4.4c.07-.73.13-1.47.18-2.2.02-.73.12-1.47-.03-2.2zM58.5 96.08v25l8 2s-5-15-8-27z"
      />
      <path
        fill="#965b44"
        d="M88.5 79.08c5.68-12.95 25.68-26.93 25.68-26.93l.59-.43c.11 1.76.02 3.04-.14 3.74-.07.31-.3.82-.46 1.01-1.92 2.36-14.67 18.42-14.67 28.6 0 0 .2 14.45.2 22.95 0 3.81-4.2 9.05-13.2 12.05l4-29-9 9c0 .01 3.01-11.88 7-20.99zM100.5 40.79c.26 4.05 3.08 3.13 3.08 3.13-3.24 1.52-7.94 2.37-10.66.56-3-2-4.42-12.39-4.42-12.39l2-6 9.44-5.53.56 20.23z"
      />
      <path
        fill="#ffcc80"
        d="M58.48 4.27C38.43 4.73 22.5 11.73 22.5 20.3c0 8.87 17.05 16.05 38.08 16.05s38.08-7.19 38.08-16.05c0-8.53-15.78-15.51-35.71-16.02"
      />
      <path
        fill="#ce8963"
        d="M58.48 4.27c-7.17.57-14.32 1.7-20.99 4.16-3.32 1.21-6.56 2.71-9.27 4.8-1.33 1.05-2.56 2.23-3.37 3.59-.84 1.34-1.18 2.84-.94 4.28.24 1.43 1.05 2.79 2.16 3.95 1.11 1.16 2.45 2.19 3.91 3.05 2.93 1.73 6.22 2.96 9.58 3.89 6.75 1.86 13.83 2.64 20.89 2.63 7.05.02 14.14-.73 20.9-2.57 3.36-.92 6.67-2.13 9.61-3.83 1.47-.85 2.84-1.84 3.96-3 1.13-1.14 2-2.48 2.28-3.91.33-1.43-.01-2.93-.77-4.29-.78-1.36-1.97-2.57-3.29-3.63-2.67-2.13-5.91-3.64-9.22-4.87-6.65-2.49-13.8-3.64-20.97-4.24 1.8-.03 3.6-.02 5.41.04 1.8.09 3.61.24 5.4.45 3.59.44 7.18 1.09 10.69 2.13 3.49 1.08 6.95 2.47 10.05 4.66 1.55 1.1 2.99 2.44 4.07 4.16 1.07 1.71 1.68 3.93 1.29 6.06-.34 2.14-1.5 3.97-2.82 5.42-1.34 1.47-2.9 2.62-4.52 3.62-3.24 1.98-6.74 3.33-10.28 4.39-7.12 2.04-14.47 2.84-21.8 2.87-7.32-.06-14.68-.87-21.79-2.95-3.54-1.07-7.03-2.45-10.26-4.45-1.61-1.01-3.15-2.2-4.48-3.69-1.3-1.48-2.4-3.37-2.68-5.51-.13-1.06-.06-2.15.21-3.18.26-1.03.74-1.96 1.29-2.81 1.11-1.7 2.59-2.99 4.14-4.08C30 9.27 33.45 7.89 36.95 6.83c3.51-1.02 7.1-1.66 10.7-2.09 1.8-.2 3.6-.35 5.41-.43 1.81-.08 3.62-.08 5.42-.04z"
      />
      <radialGradient
        id={b}
        cx={59.442}
        cy={16.159}
        r={21.667}
        gradientTransform="matrix(-1.1788 0 0 .9412 130.18 -.789)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.056} stopColor="#ffa726" />
        <stop offset={0.135} stopColor="#ffa726" />
        <stop offset={1} stopColor="#ffa726" stopOpacity={0.1} />
      </radialGradient>
      <path
        fill={`url(#${b})`}
        d="M21.91 17.65c0 7.03 14.33 12.73 32.02 12.73s32.02-5.7 32.02-12.73S79.7 2.51 53.93 4.91c-17.61 1.65-32.02 5.7-32.02 12.74z"
      />
      <path
        fill="#7f441c"
        d="M31.08 18.62c-.01 1.39.81 2.64 1.79 3.61 1.01.96 2.21 1.71 3.46 2.34 2.51 1.24 5.22 2.04 7.95 2.66 5.48 1.15 11.1 1.56 16.68 1.49 5.58-.07 11.18-.63 16.57-1.95 2.68-.68 5.33-1.55 7.75-2.8 1.2-.62 2.33-1.38 3.26-2.26.9-.9 1.57-1.98 1.54-3.08-.01-1.09-.69-2.14-1.61-3.01-.94-.86-2.07-1.58-3.28-2.17-2.42-1.19-5.07-1.99-7.75-2.61-2.69-.62-5.43-1.03-8.18-1.31-2.75-.3-5.53-.44-8.3-.46-5.55-.04-11.13.24-16.6 1.29-2.72.56-5.43 1.28-7.95 2.46-1.25.6-2.45 1.32-3.48 2.25-.99.93-1.83 2.15-1.85 3.55zm-.22 0c-.02-1.48.83-2.79 1.83-3.79 1.03-1 2.21-1.82 3.47-2.49 2.5-1.37 5.19-2.34 7.93-3.11 5.48-1.52 11.18-2.27 16.87-2.33 2.85-.01 5.7.11 8.54.39 2.84.3 5.66.78 8.45 1.46 2.78.71 5.53 1.61 8.14 2.97 1.3.68 2.55 1.5 3.67 2.57.54.55 1.05 1.17 1.44 1.89.39.72.64 1.57.63 2.44-.01.87-.27 1.71-.67 2.42s-.91 1.32-1.46 1.85c-1.12 1.04-2.38 1.83-3.69 2.47-2.61 1.29-5.36 2.13-8.14 2.77-5.56 1.25-11.24 1.71-16.9 1.67-5.65-.1-11.32-.71-16.79-2.13-2.73-.71-5.43-1.61-7.94-2.91-1.26-.64-2.45-1.43-3.49-2.4-1.01-.98-1.88-2.26-1.89-3.74z"
        opacity={0.66}
      />
      <path
        fill="#b5772c"
        d="M37.81 17.5c0 3.71 9.66 6.72 21.57 6.72s21.57-3.01 21.57-6.72-9.66-6.72-21.57-6.72-21.57 3.01-21.57 6.72zm3.68 0c0-2.78 7.62-5.04 17.03-5.04s17.03 2.26 17.03 5.04-7.62 5.04-17.03 5.04-17.03-2.26-17.03-5.04z"
        opacity={0.82}
      />
      <linearGradient
        id={c}
        x1={50.85}
        x2={67.839}
        y1={16.939}
        y2={16.939}
        gradientTransform="matrix(-1 0 0 1 120.75 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#8a5140" />
        <stop offset={1} stopColor="#8a5140" />
      </linearGradient>
      <ellipse
        cx={61.41}
        cy={16.94}
        fill={`url(#${c})`}
        opacity={0.74}
        rx={8.49}
        ry={2.24}
      />
    </svg>
  );
};
